import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=535cd577"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"
import style0 from "./ButtonDropdown.vue?vue&type=style&index=0&id=535cd577&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports